import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		searchs: '',
		id:0,
	},
	mutations: {
		changesearchs(state, ses) {
			// console.log(ses)
			this.state.searchs = ses

		}
	},
	actions: {
		setSearchKey(context, value) {
			// console.log(value)
			context.commit('changesearchs', value)
		}
	},
	modules: {}
})
